import { createOrganization } from '#~/api/agent/index.js';
import { useAuth0 } from '#~/auth/index.js';
import { useAnalytics } from '#~/analytics/hooks/index.js';
import {
  EVENT_CATEGORIES,
  EVENT_NAMES,
  WORKSPACE_PROPERTIES
} from '#~/analytics/constants/index.js';
import { CreateOrganizationDialog } from './dialog.jsx';
import type { CreateOrganizationDialogProps } from './dialog.jsx';
import { useDialog } from '@studio/design-system/dialog';

/**
 * Gets the auto tracking protection state for a specific camera.
 *
 * @returns The auto tracking protection state for the camera.
 */
export const useCreateOrganizationPrompt = (): {
  open: (onCreateStudio: (organizationId: Uint8Array) => void) => void;
} => {
  const dialog = useDialog<CreateOrganizationDialogProps>(CreateOrganizationDialog);
  const { getAccessTokenSilently } = useAuth0();
  const { track } = useAnalytics();

  const open = (onCreateStudio: (organzationId: Uint8Array) => void): void => {
    dialog.open({
      onConfirm: async (name, onSuccess, onError): Promise<void> => {
        try {
          const token = await getAccessTokenSilently();

          const id = await createOrganization(name, token);

          // Track organization creation
          track(EVENT_NAMES.CREATE_NEW_ORGANIZATION, EVENT_CATEGORIES.WORKSPACE, {
            [WORKSPACE_PROPERTIES.ORG_NAME]: name
          });

          onSuccess(id, onCreateStudio);
        } catch {
          onError();
        }
      },

      onDismiss: () => {
        dialog.close();
      }
    });
  };

  return {
    open
  };
};
